import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

import { LoginService } from '../../services/login.service';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-projects-header',
  templateUrl: './projects-header.component.html',
  styleUrls: ['./projects-header.component.css']
})
export class ProjectsHeaderComponent implements OnInit {



  @Input() value: any;
    public session_data: any = {};
  public err: any = {};
  public result: any = {};
  public projects = [];
  public form: any = {};
  public check_active: any = '';
    
   constructor(private router: Router, public fb: FormBuilder, private service: DashboardService, private login: LoginService) {
       this.session_data.name = login.get_session_data('ieye_session_name');
        this.session_data.id = login.get_session_data('ieye_session_id');
        this.session_data.role = login.get_session_data('ieye_session_role');
        this.service.setTitle('Projects | 24ieye');
    
        this.form = this.fb.group({
          user_id: [''], 
        });
   }

  ngOnInit(): void {
      this.get_projects();
	  this.check_active = setInterval(() => {
        this.is_active_user();
     }, 20000);
	const body = document.getElementsByTagName('body')[0];
    body.classList.add('nav-collapse');
  }
  
    status: boolean = false;
	clickEvent(){
		this.status = !this.status;
        if(this.status == false )
		{
			const body = document.getElementsByTagName('body')[0];
			body.classList.add('nav-collapse');
		}
		else
		{  const body = document.getElementsByTagName('body')[0];
			body.classList.remove('nav-collapse');
		}
			
	}
  public async is_active_user(){
	  if(this.session_data.id !== null){
		  if(this.session_data.role == 2){
				var formData: any = new FormData();
				formData.append("user_id", this.session_data.id);
				this.result = await this.service.form_actions(formData, 'is_active_user');
				if(this.result.status == false){
					Swal.fire({ icon: 'info', title: this.result.message});
					clearInterval(this.check_active);
					this.doLogout();
					//this.router.navigate(['projects']);
				}
		  }
	  }
  }
  
  public async doLogout() { 
      if(this.session_data.role == 2){
        this.login.create_log(this.session_data.id, 'logout');
      }
        this.login.do_logout();
  }
  
  public async get_projects() {  
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);

        this.result = await this.service.form_actions(formData, 'projects'); 
        if (this.result.status == false) {
                if (this.result.code == 202) {
                  this.err = {};
                  Swal.fire('Alert!', this.result.message, 'error');
                } else {
                  this.err = this.result.errors;
                }
        } else {
            this.projects = this.result.data;   
        }
      }
      
  public reload_if_same(e: any){
      if(e.target.className.indexOf('active') !== -1){
          this.router.onSameUrlNavigation = 'reload';
          //this.router.navigate(['admin/free-videos']);
          window.location.reload();
      }
  }

}
